// ABC SEO/GEO — Video SEO (YouTube optimization, vidIQ-style).
(function () {
  const { Icon } = window.SGIcons;
  const { Card, CardHead, PageHead } = window.SGKit;

  function ScorePill({ label, value }) {
    const c = value >= 80 ? 'var(--sg-green)' : value >= 60 ? 'var(--sg-amber)' : 'var(--sg-red, #DC2626)';
    const bg = value >= 80 ? 'var(--sg-green-50)' : value >= 60 ? 'var(--sg-amber-50)' : 'var(--sg-red-50, #FDECEC)';
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11.5, fontWeight: 700, color: c, background: bg, padding: '3px 9px', borderRadius: 'var(--sg-radius-sm)' }}>
        <span style={{ color: 'var(--sg-text-3)', fontWeight: 600 }}>{label}</span> {value}
      </span>
    );
  }

  function fmtViews(n) { return n >= 1000 ? (n / 1000).toFixed(1).replace('.0', '') + 'K' : String(n); }
  function ago(iso) {
    if (!iso) return '';
    const d = (Date.now() - new Date(iso).getTime()) / 86400000;
    if (d < 1) return 'today'; if (d < 30) return Math.round(d) + 'd ago';
    if (d < 365) return Math.round(d / 30) + 'mo ago'; return Math.round(d / 365) + 'y ago';
  }

  function VideoCard({ v, onOpen }) {
    return (
      <Card onClick={() => onOpen(v)} style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', cursor: 'pointer' }}>
        <div style={{ position: 'relative', aspectRatio: '16/9', background: 'var(--sg-sunken)' }}>
          {v.thumbnail
            ? <img src={v.thumbnail} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="play" size={26} color="var(--sg-text-3)" /></div>}
          <div style={{ position: 'absolute', top: 8, left: 8, display: 'flex', gap: 6 }}>
            <ScorePill label="Title" value={v.scores.title} />
            <ScorePill label="SEO" value={v.scores.seo} />
          </div>
        </div>
        <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--sg-text)', lineHeight: 1.35, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{v.title}</div>
          <div className="sg-tnum" style={{ fontSize: 11.5, color: 'var(--sg-text-3)', marginTop: 'auto' }}>{fmtViews(v.views)} views · {v.tags.length} tags · {ago(v.publishedAt)}</div>
        </div>
      </Card>
    );
  }

  function ConnectCTA({ onConnect, busy }) {
    return (
      <Card style={{ padding: 40, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <span style={{ width: 60, height: 60, borderRadius: 16, background: 'var(--sg-red-50, #FDECEC)', color: 'var(--sg-red, #DC2626)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="play" size={28} /></span>
        <div style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 21, color: 'var(--sg-text)' }}>Connect your YouTube channel</div>
        <p style={{ maxWidth: 460, fontSize: 13.5, color: 'var(--sg-text-2)', lineHeight: 1.6, margin: 0 }}>
          See a Title &amp; SEO score for every video, AI-suggested better titles, scored tags, and content coaching — like vidIQ, built in.
        </p>
        <button onClick={onConnect} disabled={busy} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 44, padding: '0 22px', border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.6 : 1, fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 14, color: '#fff', background: 'var(--sg-grad-brand)', boxShadow: '0 3px 10px rgba(37,99,235,0.26)' }}>
          <Icon name="play" size={16} /> {busy ? 'Opening…' : 'Connect YouTube'}
        </button>
        <div style={{ fontSize: 12, color: 'var(--sg-text-3)' }}>After connecting, come back and refresh.</div>
      </Card>
    );
  }

  function tagColor(s) { return s >= 70 ? 'var(--sg-green)' : s >= 50 ? 'var(--sg-amber)' : 'var(--sg-text-3)'; }

  // Live client-side scores (mirror the backend heuristic) so they react to edits.
  function scoreTitleC(t) {
    let s = 50; const len = (t || '').length;
    if (len >= 40 && len <= 70) s += 20; else if (len >= 30) s += 10; else if (len > 70) s -= 5; else s -= 10;
    if (/\d/.test(t)) s += 8;
    if (/\b(how|why|best|secret|fast|easy|free|new|guide|tips?|ultimate|proven)\b/i.test(t)) s += 10;
    if (t && t === t.toUpperCase() && len > 8) s -= 8;
    return Math.max(0, Math.min(100, Math.round(s)));
  }
  function scoreSeoC(desc, tags) {
    let s = 30; const dl = (desc || '').length;
    if (dl >= 250) s += 25; else if (dl >= 100) s += 15;
    if ((desc || '').includes('http')) s += 8;
    const tc = tags.length;
    if (tc >= 10) s += 25; else if (tc >= 5) s += 15; else if (tc >= 1) s += 8;
    s += 7; // thumbnail present
    return Math.max(0, Math.min(100, Math.round(s)));
  }

  function OptimizeModal({ video, onClose }) {
    const [data, setData] = React.useState(null);
    // editable working copy
    const [title, setTitle] = React.useState(video.title);
    const [desc, setDesc] = React.useState(video.description || '');
    const [tags, setTags] = React.useState(video.tags || []);
    const [newTag, setNewTag] = React.useState('');
    const [copied, setCopied] = React.useState(false);
    const [save, setSave] = React.useState({ state: 'idle' }); // idle | saving | saved | needsAuth | error

    React.useEffect(() => {
      setData(null);
      window.SGLive.optimizeYouTubeVideo(video.id).then((d) => setData(d || { error: true }));
    }, [video.id]);

    // score map for any tag (real DataForSEO score where we have it)
    const scoreMap = React.useMemo(() => {
      const m = {};
      ((data && data.tagScores) || []).forEach((t) => { m[t.tag.toLowerCase()] = t.score; });
      ((data && data.suggestedTags) || []).forEach((t) => { m[t.keyword.toLowerCase()] = t.score; });
      ((data && data.keywordData) || []).forEach((k) => { m[k.keyword.toLowerCase()] = k.score; });
      return m;
    }, [data]);
    const tagScoreOf = (t) => scoreMap[t.toLowerCase()];

    const titleScore = scoreTitleC(title);
    const seoScore = scoreSeoC(desc, tags);

    const addTag = (t) => { const k = (t || '').trim(); if (k && tags.indexOf(k) < 0) setTags(tags.concat(k)); setNewTag(''); };
    const removeTag = (t) => setTags(tags.filter((x) => x !== t));
    const dirty = title !== video.title || desc !== (video.description || '') || JSON.stringify(tags) !== JSON.stringify(video.tags || []);

    const copyAll = () => {
      const block = `TITLE:\n${title}\n\nDESCRIPTION:\n${desc}\n\nTAGS:\n${tags.join(', ')}`;
      try { navigator.clipboard.writeText(block); setCopied(true); setTimeout(() => setCopied(false), 1600); } catch (e) { /* noop */ }
    };
    const saveToYouTube = () => {
      if (save.state === 'saving') return;
      setSave({ state: 'saving' });
      window.SGLive.saveYouTubeVideo(video.id, { title, description: desc, tags }).then((r) => {
        if (r.ok) {
          setSave({ state: 'saved' });
          // reflect the new "original" so the dirty flag clears
          video.title = title; video.description = desc; video.tags = tags.slice();
          setTimeout(() => setSave({ state: 'idle' }), 2500);
        } else if (r.error === 'needs_write_access') {
          setSave({ state: 'needsAuth' });
        } else {
          setSave({ state: 'error' });
        }
      });
    };
    const reconnect = () => { window.SGLive.reconnectGoogle(); };

    // Suggestions arrive five at a time; "Show 5 more" appends the NEXT five
    // rather than replacing them, so nothing already on screen disappears.
    const [extraTags, setExtraTags] = React.useState([]);
    const [moreBusy, setMoreBusy] = React.useState(false);
    const [paging, setPaging] = React.useState(null);
    React.useEffect(() => { setExtraTags([]); setPaging((data && data.tagPaging) || null); }, [data]);
    const showMore = () => {
      if (moreBusy || !paging || !paging.hasMore) return;
      setMoreBusy(true);
      window.SGLive.moreVideoTags(video.id, paging.nextOffset).then((r) => {
        setMoreBusy(false);
        if (!r) return;
        setExtraTags((prev) => prev.concat(r.suggestions || []));
        setPaging({ nextOffset: r.nextOffset, hasMore: r.hasMore, total: r.total });
      });
    };
    const suggestedTags = ((data && data.suggestedTags) || []).concat(extraTags);
    const freshSuggested = suggestedTags.filter((s) => tags.indexOf(s.keyword) < 0);

    return (
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(12,14,40,0.55)', backdropFilter: 'blur(3px)', zIndex: 60, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 20px', overflow: 'auto', animation: 'sg-fade 0.2s var(--sg-ease)' }}>
        <Card onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 780, overflow: 'hidden', display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 80px)' }}>
          {/* header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px', borderBottom: '1px solid var(--sg-border)', flex: 'none' }}>
            {video.thumbnail && <img src={video.thumbnail} alt="" style={{ width: 64, height: 36, borderRadius: 6, objectFit: 'cover', flex: 'none' }} />}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--sg-text)' }}>Optimize video</div>
              <div style={{ fontSize: 12, color: 'var(--sg-text-3)' }}>{fmtViews(video.views)} views · {ago(video.publishedAt)}</div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}><ScorePill label="Title" value={titleScore} /><ScorePill label="SEO" value={seoScore} /></div>
            <button onClick={onClose} aria-label="Close" style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid var(--sg-border)', background: 'var(--sg-card)', cursor: 'pointer', color: 'var(--sg-text-3)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}><Icon name="x" size={16} /></button>
          </div>

          <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 22, overflowY: 'auto' }}>
            {/* TITLE */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--sg-text)' }}>Title</span>
                <span className="sg-tnum" style={{ fontSize: 11.5, color: title.length > 70 ? 'var(--sg-amber)' : 'var(--sg-text-3)' }}>{title.length}/70</span>
              </div>
              <textarea value={title} onChange={(e) => setTitle(e.target.value)} rows={2}
                style={{ width: '100%', resize: 'vertical', padding: '10px 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 14, color: 'var(--sg-text)', outline: 'none', lineHeight: 1.4, boxSizing: 'border-box' }} />
              {/* grounded AI suggestions */}
              <div style={{ marginTop: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 8 }}>
                  <Icon name="sparkles" size={14} color="var(--sg-violet-600)" />
                  <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--sg-text-2)' }}>AI suggestions</span>
                  {data && data.topic && <span style={{ fontSize: 11, color: 'var(--sg-text-3)' }}>· read as “{data.topic}”</span>}
                </div>
                {!data ? <div style={{ fontSize: 12.5, color: 'var(--sg-text-3)' }}>Analyzing…</div>
                  : (data.titleSuggestions || []).length === 0 ? <div style={{ fontSize: 12.5, color: 'var(--sg-text-3)' }}>No suggestions returned.</div>
                  : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {data.titleSuggestions.map((t, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)' }}>
                          <span style={{ flex: 1, fontSize: 13.5, color: 'var(--sg-text)' }}>{t}</span>
                          <button onClick={() => setTitle(t)} style={{ flex: 'none', fontSize: 12, fontWeight: 700, color: 'var(--sg-blue-600)', background: 'var(--sg-blue-50)', border: 'none', borderRadius: 'var(--sg-radius-pill)', padding: '5px 13px', cursor: 'pointer' }}>Use</button>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            </div>

            {/* DESCRIPTION */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--sg-text)' }}>Description</span>
                <span className="sg-tnum" style={{ fontSize: 11.5, color: desc.length < 250 ? 'var(--sg-amber)' : 'var(--sg-text-3)' }}>{desc.length} chars{desc.length < 250 ? ' · aim for 250+' : ''}</span>
              </div>
              <textarea value={desc} onChange={(e) => setDesc(e.target.value)} rows={5}
                placeholder="Describe the video with your keywords and a link…"
                style={{ width: '100%', resize: 'vertical', padding: '10px 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 13.5, color: 'var(--sg-text)', outline: 'none', lineHeight: 1.5, boxSizing: 'border-box' }} />
            </div>

            {/* TAGS */}
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--sg-text)', marginBottom: 8 }}>Tags <span style={{ fontWeight: 500, color: 'var(--sg-text-3)' }}>· {tags.length} · scored by real search demand</span></div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
                {tags.length === 0 && <span style={{ fontSize: 12.5, color: 'var(--sg-text-3)' }}>No tags yet — add 8–15 from the suggestions below.</span>}
                {tags.map((t) => {
                  const sc = tagScoreOf(t);
                  return (
                    <span key={t} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text)', background: 'var(--sg-sunken)', border: '1px solid var(--sg-border)', padding: '4px 6px 4px 10px', borderRadius: 'var(--sg-radius-pill)' }}>
                      {sc != null && <b style={{ color: tagColor(sc) }}>{sc}</b>} {t}
                      <button onClick={() => removeTag(t)} aria-label="Remove" style={{ width: 18, height: 18, borderRadius: '50%', border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--sg-text-3)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="x" size={12} /></button>
                    </span>
                  );
                })}
              </div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                <input value={newTag} onChange={(e) => setNewTag(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') addTag(newTag); }}
                  placeholder="Add a tag…"
                  style={{ flex: 1, height: 38, padding: '0 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 13, color: 'var(--sg-text)', outline: 'none' }} />
                <button onClick={() => addTag(newTag)} disabled={!newTag.trim()} style={{ height: 38, padding: '0 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-card)', color: 'var(--sg-blue-600)', cursor: newTag.trim() ? 'pointer' : 'not-allowed', opacity: newTag.trim() ? 1 : 0.5, fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 13 }}>Add</button>
              </div>
              {/* suggested tags from real keyword data */}
              {/* Rendered whenever there is anything to show OR anything more to
                  fetch. The button used to live inside the "has unused chips"
                  branch, so using all five made it vanish — exactly when the
                  next five are wanted. */}
              {(!data || freshSuggested.length > 0 || (paging && paging.hasMore) || !data.error) && (
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'var(--sg-text-3)', marginBottom: 8 }}>Suggested keyphrases — high search, low competition first</div>
                  {!data && (
                    <div style={{ fontSize: 12, color: 'var(--sg-text-3)', marginBottom: 8 }}>
                      Reading this video and checking real search demand…
                    </div>
                  )}
                  {data && freshSuggested.length === 0 && (
                    <div style={{ fontSize: 12, color: 'var(--sg-text-3)', marginBottom: 8 }}>
                      {paging && paging.hasMore
                        ? 'All of these are on your tag list — get the next five below.'
                        : 'No more keyphrase ideas matched this video closely enough. A fuller description helps — we read the title and description to work out the subject.'}
                    </div>
                  )}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {freshSuggested.map((s) => (
                      <button key={s.keyword} onClick={() => addTag(s.keyword)} title={[s.search_volume != null ? s.search_volume.toLocaleString() + ' searches/mo' : null, s.relevance != null ? Math.round(s.relevance * 100) + '% match to this video' : null].filter(Boolean).join(' · ')}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text)', background: 'var(--sg-card)', border: '1px dashed var(--sg-border-2)', padding: '4px 11px', borderRadius: 'var(--sg-radius-pill)', cursor: 'pointer' }}>
                        <b style={{ color: tagColor(s.score) }}>{s.score}</b> {s.keyword} <Icon name="plus" size={12} color="var(--sg-blue-600)" />
                      </button>
                    ))}
                  </div>
                  {paging && paging.hasMore ? (
                    <button onClick={showMore} disabled={moreBusy}
                      style={{ marginTop: 10, display: 'inline-flex', alignItems: 'center', gap: 6, height: 32, padding: '0 14px', borderRadius: 'var(--sg-radius-pill)', border: '1px solid var(--sg-border)', background: 'var(--sg-card)', color: 'var(--sg-blue-600)', cursor: moreBusy ? 'wait' : 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12 }}>
                      <Icon name="plus" size={13} /> {moreBusy ? 'Finding more…' : 'Show 5 more'}
                    </button>
                  ) : null}
                </div>
              )}
            </div>

            {/* content coaching — next (vidIQ "Review" equivalent) */}
            <div style={{ padding: 12, borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-sunken)', border: '1px dashed var(--sg-border)', display: 'flex', alignItems: 'center', gap: 11 }}>
              <Icon name="activity" size={16} color="var(--sg-text-3)" />
              <div style={{ fontSize: 12, color: 'var(--sg-text-2)' }}><strong style={{ color: 'var(--sg-text)' }}>Content coaching</strong> — timestamped feedback on your hook, pacing & CTA is coming next.</div>
            </div>
          </div>

          {/* footer actions — save directly back to YouTube */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px', borderTop: '1px solid var(--sg-border)', flex: 'none', background: 'var(--sg-card)', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 180, fontSize: 12.5,
              color: save.state === 'saved' ? 'var(--sg-green)' : save.state === 'needsAuth' || save.state === 'error' ? 'var(--sg-amber)' : dirty ? 'var(--sg-text-2)' : 'var(--sg-text-3)' }}>
              {save.state === 'saved' ? '✓ Saved to YouTube — your video is updated.'
                : save.state === 'needsAuth' ? 'YouTube needs write access. Reconnect to grant it (one time), then Save again.'
                : save.state === 'error' ? 'Couldn’t save — try again, or use Copy as a fallback.'
                : dirty ? 'You have unsaved edits.' : 'Edit the title, description and tags, then save.'}
            </div>
            <button onClick={copyAll} title="Copy title + description + tags as text"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 40, padding: '0 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-card)', color: 'var(--sg-text-2)', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 13 }}>
              <Icon name={copied ? 'check' : 'copy'} size={15} color={copied ? 'var(--sg-green)' : 'var(--sg-text-3)'} /> {copied ? 'Copied' : 'Copy'}
            </button>
            {save.state === 'needsAuth'
              ? <button onClick={reconnect} style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 40, padding: '0 18px', border: 'none', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-grad-brand)', color: '#fff', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 13 }}>
                  <Icon name="play" size={14} /> Reconnect YouTube
                </button>
              : <button onClick={saveToYouTube} disabled={save.state === 'saving' || !dirty}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 40, padding: '0 20px', border: 'none', borderRadius: 'var(--sg-radius-pill)', background: (save.state === 'saving' || !dirty) ? 'var(--sg-text-3)' : 'var(--sg-grad-brand)', color: '#fff', cursor: (save.state === 'saving' || !dirty) ? 'default' : 'pointer', opacity: (save.state === 'saving' || !dirty) ? 0.7 : 1, fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 13, boxShadow: '0 3px 10px rgba(37,99,235,0.26)' }}>
                  <Icon name={save.state === 'saved' ? 'check' : 'play'} size={14} /> {save.state === 'saving' ? 'Saving…' : save.state === 'saved' ? 'Saved' : 'Save to YouTube'}
                </button>}
          </div>
        </Card>
      </div>
    );
  }

  function VideoSEO() {
    const [state, setState] = React.useState({ loading: true });
    const [busy, setBusy] = React.useState(false);
    const [selected, setSelected] = React.useState(null);
    const load = React.useCallback(() => {
      setState({ loading: true });
      window.SGLive.fetchYouTubeVideos().then((r) => {
        if (r.ok) setState({ loading: false, videos: r.videos });
        else setState({ loading: false, notConnected: true });
      });
    }, []);
    React.useEffect(() => { load(); }, [load]);
    const connect = () => { setBusy(true); window.SGLive.connectGoogle('youtube').then(() => setBusy(false)); };

    const videos = state.videos || [];
    const avgT = videos.length ? Math.round(videos.reduce((a, v) => a + v.scores.title, 0) / videos.length) : 0;
    const avgS = videos.length ? Math.round(videos.reduce((a, v) => a + v.scores.seo, 0) / videos.length) : 0;

    return (
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
        <PageHead eyebrow="Optimize" title="Video SEO" icon="play" sub="Optimize your YouTube videos — title, tags & content scores."
          right={!state.loading && !state.notConnected
            ? <button onClick={load} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 38, padding: '0 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-card)', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: 'var(--sg-text-2)' }}><Icon name="refresh-cw" size={14} /> Refresh</button>
            : null} />

        {state.loading
          ? <Card style={{ padding: 22, fontSize: 13, color: 'var(--sg-text-2)' }}>Loading your videos…</Card>
          : state.notConnected
            ? <ConnectCTA onConnect={connect} busy={busy} />
            : videos.length === 0
              ? <Card style={{ padding: 22, fontSize: 13, color: 'var(--sg-text-2)' }}>No videos found on the connected channel yet.</Card>
              : (
                <React.Fragment>
                  <Card style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', overflow: 'hidden' }}>
                    {[['Videos', String(videos.length), 'var(--sg-text)'], ['Avg. title score', String(avgT), avgT >= 70 ? 'var(--sg-green)' : 'var(--sg-amber)'], ['Avg. SEO score', String(avgS), avgS >= 70 ? 'var(--sg-green)' : 'var(--sg-amber)']].map(([l, val, col], i) => (
                      <div key={l} style={{ padding: '16px 20px', borderLeft: i ? '1px solid var(--sg-border)' : 'none' }}>
                        <div className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 24, color: col, lineHeight: 1 }}>{val}</div>
                        <div style={{ fontSize: 12, color: 'var(--sg-text-2)', marginTop: 5 }}>{l}</div>
                      </div>
                    ))}
                  </Card>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 18 }}>
                    {videos.map((v) => <VideoCard key={v.id} v={v} onOpen={setSelected} />)}
                  </div>
                </React.Fragment>
              )}
        {selected && <OptimizeModal video={selected} onClose={() => setSelected(null)} />}
      </div>
    );
  }

  window.SGVideo = VideoSEO;
})();
